<template lang="pug">
.stage-bar
  .tags
    .tag.top(v-for='tag in tags', v-if='tag.top', :style='{ left: get_percent_tag(tag)+"%" }') {{tag.top}}
  .ui.progress.active(:class='classes')
    .bar(style='transition-duration: 300ms;', :style='{ width : computed_percent+"%", background: color }', :class='barClass')
      .progress(v-if='showProgress') {{computed_percent}}%
    .indicators
      .indicator(v-for='tag of tags', :style='{ left: get_percent_tag(tag)+"%" }', :class='{top:tag.top, bottom:tag.bottom}')
    .label(v-if='label') {{label}}
  .tags
    .tag.bottom(v-for='tag in tags', v-if='tag.bottom', :style='{ left: get_percent_tag(tag)+"%" }') {{tag.bottom}}
</template>

<script>
export default {
  name: 'stage-bar',
  props: {
    classes: String,
    color: String,
    barClass: String,
    percent: null,
    min: { default: 0 },
    max: { default: 100 },
    value: { default: 0 },
    label: String,
    tags: Array,
    showProgress: { type: Boolean, default: false },
  },
  computed: {
    computed_percent() {
      if (this.percent != null)
        return this.percent
      return this.get_percent(this.value)
    },
  },
  methods: {
    get_percent(value) {
      return ((value - this.min) / (this.max - this.min)) * 100
    },
    get_percent_tag(tag) {
      if (tag.percent != null)
        return tag.percent
      return this.get_percent(tag.position)
    },
  },

}
</script>



// WEBPACK FOOTER //
// StageBar.vue?11fbe44d